export function debounce(fn, wait = 60) {
  var timeout = null;     
  return function () {
      const arg = arguments
      if(timeout !== null) {
          clearTimeout(timeout);
      }
      timeout = setTimeout( () => fn.apply( this, arg), wait);  
  }
}


// WEBPACK FOOTER //
// ./src/extend/debounce.js